import { render, staticRenderFns } from "./AboutWarnings.vue?vue&type=template&id=0137b1a5&scoped=true"
import script from "./AboutWarnings.vue?vue&type=script&lang=js"
export * from "./AboutWarnings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0137b1a5",
  null
  
)

export default component.exports